/* eslint-disable */

import { AppConfig } from '../AppConfig';
import { Helper } from '../common/helpers/Helper'
import moment from 'moment';
export const graphColorsForEachAdTypes = {
  "pop": '#9B59B6',
  "get": '#1E90FF',
  "leased": '#2ECC71',
  "error": '#E74C3C'
}

export const DP_DISPLAY_NAME_MAP = {
  AD: 'Axelerant',
  AK: 'Addesk',
  BO: 'Broad',
  FR: 'Framen',
  HI: 'HiveStack',
  IN: 'Indicue',
  LO: 'Loop',
  PO: 'PlaceExchange OTT',
  PU: 'Publica',
  PX: 'PlaceExchange',
  VC: 'VC (Content)',
  VH: 'Viooh',
  VI: 'Vistar',
  VS: 'Vesta',
  DD: 'DD (OTT)'
}

export const formatDpName = (dp = '') => {
  const dpKey = String(dp || '').toUpperCase()
  return DP_DISPLAY_NAME_MAP[dpKey] || dp
}

export const campaignGraphicFields2 = {
  "fieldDef": {
    title: 'Creatives',
    formType: 'add',
    "steps": [
      {
        "fields": [
          {
            "key": "title",
            "type": "edit_text",
            "label": "Title",
            "hint": "Provide title",
            "v_required": {
              "value": true,
              "err": "Provide title"
            },
            "v_min": {
              "value": 2,
              "err": "Title is too short (2 - 100)"
            },
            "v_max": {
              "value": 100,
              "err": "Title is too long (2 - 100)"
            },
            "placement": "left"
          },
          {
            "key": "imageName",
            "linkName": "image",
            "type": "edit_text",
            "label": "Image (1920x1080 or 1080x1920 px) (png/jpg)",
            "imageWidth": 1920,
            "hint": "Upload the image",
            "v_required": {
              "value": false,
              "err": "Upload the Logo"
            },
            "v_min": {
              "value": 1,
              "err": "Invalid Image"
            },
            "v_max": {
              "value": 100,
              "err": "Invalid Image"
            },
            "mode": "fit",
            "imageUpload": true,
            "uploadType": "media",
            "uploadAccept": "image/png, image/jpeg",
            "placement": "left"
          }
        ]
      }
    ]
  }
}

export const campaignGraphicFields = {
  "fieldDef": {
    title: 'Creatives',
    "steps": [
      {
        "fields": [
          {
            "key": "title",
            "type": "edit_text",
            "label": "Nickname (for internal reference)",
            "hint": "Provide Nickname",
            "v_required": {
              "value": true,
              "err": "Provide Nickname"
            },
            "v_min": {
              "value": 2,
              "err": "Nickname is too short (2 - 100)"
            },
            "v_max": {
              "value": 100,
              "err": "Nickname is too long (2 - 100)"
            },
            "placement": "left"
          },
          {
            "key": "state",
            "type": "radio",
            "label": "Status",
            "hint": "Select Status",
            "hide": true,
            "options": [
              {
                "key": "LIVE",
                "label": "LIVE"
              },
              {
                "key": "DISABLED",
                "label": "DISABLED"
              }
            ],
            "defaultValue": "LIVE",
            "v_required": {
              "value": true,
              "err": "Select Status"
            },
            "placement": "right"
          },
          {
            "key": "order",
            "type": "edit_text",
            "label": "Ad Display Order",
            "hint": "Provide order(3 digits)",
            "defaultValue": "001",
            "v_required": {
              "value": true,
              "err": "Provide valid order"
            },
            "v_min": {
              "value": 3,
              "err": "Order is too short. Enter 3 digits."
            },
            "v_max": {
              "value": 3,
              "err": "Order is too long. Enter 3 digits."
            },
            "placement": "left"
          },
          {
            "key": "iType",
            "type": "radio",
            "label": "Type",
            "hint": "Select type",
            "hide": false,
            "options": [
              {
                "key": "IMAGE",
                "label": "IMAGE"
              },
              {
                "key": "VIDEO",
                "label": "VIDEO"
              }
            ],
            "defaultValue": "IMAGE",
            "v_required": {
              "value": true,
              "err": "Select Type"
            },
            "placement": "right"
          },
          {
            "key": "contentName",
            "condition": {
              "key": "iType",
              "value": "IMAGE"
            },
            "linkName": "content",
            "_inputImageHeightName": "contentHeight",
            "_inputImageWidthName": "contentWidth",
            "type": "edit_text",
            "label": "Image (1920x1080 or 1080x1920 px) (png/jpg)",
            "hint": "Upload the image",
            "v_required": {
              "value": true,
              "err": "Upload the image"
            },
            "v_min": {
              "value": 1,
              "err": "Invalid image"
            },
            "v_max": {
              "value": 100,
              "err": "Invalid image"
            },
            "imageUpload": true,
            "imageWidth": 1920,
            "imageHeight": 1080,
            "mode": "exact_interchangeable",
            "uploadType": "media",
            "uploadExt": "jpg",
            "uploadAccept": "image/png, image/jpeg",
            "placement": "left"
          },
          {
            "key": "contentHeight",
            "type": "edit_text",
            "label": "Content height (px)",
            "hint": "Provide content height",
            "hide": true,
            "v_required": {
              "value": false,
              "err": "Provide content height"
            },
            "v_int": {
              "value": true,
              "err": "Provide content height"
            },
            "placement": "left",
            "hide": true,
          },
          {
            "key": "contentWidth",
            "type": "edit_text",
            "label": "Content width (px)",
            "hint": "Provide content width",
            "hide": true,
            "v_required": {
              "value": false,
              "err": "Provide content width"
            },
            "v_int": {
              "value": true,
              "err": "Provide content width"
            },
            "placement": "left",
            "hide": true
          },
          {
            "key": "durationSecs",
            "type": "edit_text",
            "label": "Duration (Secs)",
            "hint": "Provide Duration",
            "hide": true,
            "v_required": {
              "value": true,
              "err": "Provide Duration"
            },
            "v_int": {
              "value": true,
              "err": "Provide Duration"
            },
            "v_min": {
              "value": 3,
              "err": "Duration is too less (3 to 60 secs)"
            },
            "v_max": {
              "value": 60,
              "err": "Duration is too high (3 to 60 secs)"
            },
            "defaultValue": 10,
            "placement": "left"
          },
          {
            "condition": {
              "key": "iType",
              "value": "VIDEO"
            },
            "key": "contentName",
            "linkName": "content",
            "type": "edit_text",
            "label": "Video (mp4) (1920x1080 or 1080x1920 px, Max Duration: 90s, Max File Size: 50Mb)",
            "hint": "Upload the video",
            "v_required": {
              "value": true,
              "err": "Upload the video"
            },
            "v_min": {
              "value": 1,
              "err": "Invalid video"
            },
            "v_max": {
              "value": 500,
              "err": "Invalid video"
            },
            "documentUpload": true,
            "uploadType": "media",
            "uploadAccept": "video/mp4",
            "placement": "left",
            "autoFillField": "durationSecs",
            "autoFillVideoDuration": true,
            "autoFillTitleKey": "title",
            "maxVideoDuration": 90,
            "maxWidthOrHeight": 1920,
            "mode": "exact_interchangeable",
            "videoWidth": 1080,
            "videoHeight": 1920,
            "fileSizeLimit": 50000000,
            "_inputVideoHeightName": "contentHeight",
            "_inputVideoWidthName": "contentWidth",
          }
        ]
      }
    ]
  }
}

export const campaignFields = {
  "fieldDef": {
    title: 'Campaign',
    "steps": [
      {
        "fields": [
          {
            "key": "title",
            "type": "edit_text",
            "label": "Title",
            "hint": "Provide title",
            "v_required": {
              "value": true,
              "err": "Provide title"
            },
            "v_min": {
              "value": 2,
              "err": "Title is too short (2 - 100)"
            },
            "v_max": {
              "value": 100,
              "err": "Title is too long (2 - 100)"
            },
            "placement": "left"
          },
          {
            "key": "startTs",
            "type": "date",
            "label": "Start date",
            "hint": "Provide start date",
            "v_required": {
              "value": true,
              "err": "Provide start date"
            },
            "placement": "right",
            "disablePast": true
          },
        ]
      }
    ]
  }
}

export const campaignDatesFields = {
  "fieldDef": {
    title: Helper.getString('campaignDuration'),
    "steps": [
      {
        "fields": [
          {
            "key": "startTs",
            "type": "date",
            "label": "Start date",
            "hint": "Provide start date",
            "v_required": {
              "value": true,
              "err": "Provide start date"
            },
            "placement": "left",
            "disablePast": true
          },
          {
            "key": "endTs",
            "type": "date",
            "label": "End date",
            "hint": "Provide end date",
            "v_required": {
              "value": false,
              "err": "Provide end date"
            },
            "placement": "right",
            "disablePast": true
          }
        ]
      }
    ]
  }
}

export const campaignAdFrequencyField = {
  key: 'adFrequency',
  label: 'Ad Frequency',
  type: 'select',
  inputImage: require('../assets/images/list-icon.svg'),
  imageAlt: 'Location Icon Image',
  value: '',
  placeholder: 'Select the Ad Frequency',
  tip: Helper.getString('adInfo'),
  items: [
    {
      key: '1',
      value: '1',
      frequency: 1
    },
    {
      key: '2',
      value: '2',
      frequency: 2
    },
    {
      key: '3',
      value: '3',
      frequency: 3
    },
    {
      key: '4',
      value: '4',
      frequency: 4
    },
    {
      key: '5',
      value: '5',
      frequency: 5
    }
  ]
}

export const venueMarkerData = {
  items: [
    {
      location: {
        lat: 40.7127753,
        lng: -74.0059728
      }
    },
    {
      location: {
        lat: 40.7921353,
        lng: -74.5059728
      }
    },
    {
      location: {
        lat: 40.7627753,
        lng: -74.0459728
      }
    },
    {
      location: {
        lat: 40.7927753,
        lng: -74.0859728
      }
    },
    {
      location: {
        lat: 40.700000,
        lng: -74.0459728
      }
    },
    {
      location: {
        lat: 40.73475453,
        lng: -74.0462364
      }
    }
  ]
}
const timeIntervals = [
  { "key": "07:00 AM", "text": "07:00 AM" },
  { "key": "07:15 AM", "text": "07:15 AM" },
  { "key": "07:30 AM", "text": "07:30 AM" },
  { "key": "07:45 AM", "text": "07:45 AM" },
  { "key": "08:00 AM", "text": "08:00 AM" },
  { "key": "08:15 AM", "text": "08:15 AM" },
  { "key": "08:30 AM", "text": "08:30 AM" },
  { "key": "08:45 AM", "text": "08:45 AM" },
  { "key": "09:00 AM", "text": "09:00 AM" },
  { "key": "09:15 AM", "text": "09:15 AM" },
  { "key": "09:30 AM", "text": "09:30 AM" },
  { "key": "09:45 AM", "text": "09:45 AM" },
  { "key": "10:00 AM", "text": "10:00 AM" },
  { "key": "10:15 AM", "text": "10:15 AM" },
  { "key": "10:30 AM", "text": "10:30 AM" },
  { "key": "10:45 AM", "text": "10:45 AM" },
  { "key": "11:00 AM", "text": "11:00 AM" },
  { "key": "11:15 AM", "text": "11:15 AM" },
  { "key": "11:30 AM", "text": "11:30 AM" },
  { "key": "11:45 AM", "text": "11:45 AM" },
  { "key": "12:00 PM", "text": "12:00 PM" },
  { "key": "12:15 PM", "text": "12:15 PM" },
  { "key": "12:30 PM", "text": "12:30 PM" },
  { "key": "12:45 PM", "text": "12:45 PM" },
  { "key": "01:00 PM", "text": "01:00 PM" },
  { "key": "01:15 PM", "text": "01:15 PM" },
  { "key": "01:30 PM", "text": "01:30 PM" },
  { "key": "01:45 PM", "text": "01:45 PM" },
  { "key": "02:00 PM", "text": "02:00 PM" },
  { "key": "02:15 PM", "text": "02:15 PM" },
  { "key": "02:30 PM", "text": "02:30 PM" },
  { "key": "02:45 PM", "text": "02:45 PM" },
  { "key": "03:00 PM", "text": "03:00 PM" },
  { "key": "03:15 PM", "text": "03:15 PM" },
  { "key": "03:30 PM", "text": "03:30 PM" },
  { "key": "03:45 PM", "text": "03:45 PM" },
  { "key": "04:00 PM", "text": "04:00 PM" },
  { "key": "04:15 PM", "text": "04:15 PM" },
  { "key": "04:30 PM", "text": "04:30 PM" },
  { "key": "04:45 PM", "text": "04:45 PM" },
  { "key": "05:00 PM", "text": "05:00 PM" },
  { "key": "05:15 PM", "text": "05:15 PM" },
  { "key": "05:30 PM", "text": "05:30 PM" },
  { "key": "05:45 PM", "text": "05:45 PM" },
  { "key": "06:00 PM", "text": "06:00 PM" },
  { "key": "06:15 PM", "text": "06:15 PM" },
  { "key": "06:30 PM", "text": "06:30 PM" },
  { "key": "06:45 PM", "text": "06:45 PM" },
  { "key": "07:00 PM", "text": "07:00 PM" },
  { "key": "07:15 PM", "text": "07:15 PM" },
  { "key": "07:30 PM", "text": "07:30 PM" },
  { "key": "07:45 PM", "text": "07:45 PM" },
  { "key": "08:00 PM", "text": "08:00 PM" },
  { "key": "08:15 PM", "text": "08:15 PM" },
  { "key": "08:30 PM", "text": "08:30 PM" },
  { "key": "08:45 PM", "text": "08:45 PM" },
  { "key": "09:00 PM", "text": "09:00 PM" },
  { "key": "09:15 PM", "text": "09:15 PM" },
  { "key": "09:30 PM", "text": "09:30 PM" },
  { "key": "09:45 PM", "text": "09:45 PM" },
  { "key": "10:00 PM", "text": "10:00 PM" },
  { "key": "10:15 PM", "text": "10:15 PM" },
  { "key": "10:30 PM", "text": "10:30 PM" },
  { "key": "10:45 PM", "text": "10:45 PM" },
  { "key": "11:00 PM", "text": "11:00 PM" },
  { "key": "11:15 PM", "text": "11:15 PM" },
  { "key": "11:30 PM", "text": "11:30 PM" },
  { "key": "11:45 PM", "text": "11:45 PM" },
  { "key": "12:00 AM", "text": "12:00 AM" },
  { "key": "12:15 AM", "text": "12:15 AM" },
  { "key": "12:30 AM", "text": "12:30 AM" },
  { "key": "12:45 AM", "text": "12:45 AM" },
  { "key": "01:00 AM", "text": "01:00 AM" },
  { "key": "01:15 AM", "text": "01:15 AM" },
  { "key": "01:30 AM", "text": "01:30 AM" },
  { "key": "01:45 AM", "text": "01:45 AM" },
  { "key": "02:00 AM", "text": "02:00 AM" },
  { "key": "02:15 AM", "text": "02:15 AM" },
  { "key": "02:30 AM", "text": "02:30 AM" },
  { "key": "02:45 AM", "text": "02:45 AM" },
  { "key": "03:00 AM", "text": "03:00 AM" },
  { "key": "03:15 AM", "text": "03:15 AM" },
  { "key": "03:30 AM", "text": "03:30 AM" },
  { "key": "03:45 AM", "text": "03:45 AM" },
  { "key": "04:00 AM", "text": "04:00 AM" },
  { "key": "04:15 AM", "text": "04:15 AM" },
  { "key": "04:30 AM", "text": "04:30 AM" },
  { "key": "04:45 AM", "text": "04:45 AM" },
  { "key": "05:00 AM", "text": "05:00 AM" },
  { "key": "05:15 AM", "text": "05:15 AM" },
  { "key": "05:30 AM", "text": "05:30 AM" },
  { "key": "05:45 AM", "text": "05:45 AM" },
  { "key": "06:00 AM", "text": "06:00 AM" },
  { "key": "06:15 AM", "text": "06:15 AM" },
  { "key": "06:30 AM", "text": "06:30 AM" },
  { "key": "06:45 AM", "text": "06:45 AM" }
]

export const campaignRecurFields = {
  fieldDef: {
    title: 'Campaign Recurrence',
    formType: 'edit',
    steps: [
      {
        fields: [
          {
            key: 'startStr',
            disablePast: true,
            type: 'dateTimeStr',
            label: 'Start',
            hint: 'Provide start',
            placeholder: 'MM-DD-YYYY',
            v_required: {
              value: false,
              err: 'Provide start'
            },
            placement: 'left',
            clearable: true
          },
          {
            key: 'endStr',
            disablePast: true,
            type: 'dateTimeStr',
            label: 'End',
            hint: 'Provide end',
            placeholder: 'MM-DD-YYYY',
            v_required: {
              value: false,
              err: 'Provide end'
            },
            placement: 'right',
            clearable: true
          },
          // {
          //   key: 'startTs',
          //   type: 'dateTime',
          //   label: 'Start',
          //   hint: 'Provide start',
          //   placeholder: 'MM-DD-YYYY',
          //   v_required: {
          //     value: false,
          //     err: 'Provide start'
          //   },
          //   placement: 'left',
          //   clearable: true
          // },
          // {
          //   key: 'endTs',
          //   type: 'dateTime',
          //   label: 'End',
          //   hint: 'Provide end',
          //   placeholder: 'MM-DD-YYYY',
          //   v_required: {
          //     value: false,
          //     err: 'Provide end'
          //   },
          //   placement: 'right',
          //   clearable: true
          // },
          {
            key: 'startTime',
            type: 'radio',
            label: 'Play from',
            hint: 'Provide play from time',
            placeholder: 'hh:mm a',
            v_required: {
              value: false,
              err: 'Provide play from time'
            },
            v_min: {
              value: 2,
              err: 'Play from time is too short'
            },
            v_max: {
              value: 200,
              err: 'Play from time is too long (max 200)'
            },
            placement: 'left',
            options: timeIntervals
          },
          {
            key: 'endTime',
            type: 'radio',
            label: 'Play to',
            hint: 'Provide play to',
            placeholder: 'hh:mm a',
            v_required: {
              value: false,
              err: 'Provide play to'
            },
            v_min: {
              value: 2,
              err: 'Play to time is too short'
            },
            v_max: {
              value: 200,
              err: 'Play to is too long (max 200)'
            },
            placement: 'right',
            defaultValue: 900,
            options: timeIntervals
          },
          {
            key: 'recur',
            type: 'check_box',
            label: 'Days',
            hint: 'Days',
            options: [
              { key: 'SU', label: 'SUNDAY' },
              { key: 'MO', label: 'MONDAY' },
              { key: 'TU', label: 'TUESDAY' },
              { key: 'WE', label: 'WEDNESDAY' },
              { key: 'TH', label: 'THURSDAY' },
              { key: 'FR', label: 'FRIDAY' },
              { key: 'SA', label: 'SATURDAY' }
            ],
            placement: 'left',
            v_required: { value: false, err: 'Select a day' }
          }
        ]
      }
    ]
  }
}
export const downloadVenueFieldDef = {
  fieldDef: {
    title: 'Download Screens',
    formType: 'edit',
    steps: [
      {
        fields: [
          {
            key: 'action',
            type: 'radio',
            label: 'Action',
            hint: 'Select Job Type',
            placeholder: 'job',
            v_required: {
              value: true,
              err: 'Provide job action'
            },
            placement: 'left',
            options: [
              {
                "key": "EXPORT_VENUES_SELECTED",
                "label": "EXPORT_VENUES_SELECTED"
              }
            ],
            value: 'EXPORT_VENUES_SELECTED',
            disabled: true
          }
        ]
      }
    ]
  }
}

export const getDownloadDeviceActivityFieldDef = () => ({
  fieldDef: {
    title: 'Download per Screen per Hour',
    formType: 'edit',
    ctaButtonText: 'Run',
    steps: [
      {
        fields: [
          {
            key: 'action',
            type: 'radio',
            label: 'Action',
            hint: 'Select Job Type',
            placeholder: 'job',
            v_required: { value: true, err: 'Provide job action' },
            placement: 'left',
            options: [{ key: 'VENUE_EXCHANGE_REPORT', label: 'VENUE_EXCHANGE_REPORT' }],
            value: 'VENUE_EXCHANGE_REPORT',
            disabled: true,
          },
          {
            key: 'startPeriod',
            type: 'date',
            label: 'Start date (CST)',
            hint: 'Provide start date',
            value: moment().tz(AppConfig.DEFAULT_ZONEINFO).subtract(7, 'days').format('YYYYMMDD'),
            v_required: { value: true, err: 'Provide start date' },
            placement: 'left',
          },
          {
            key: 'endPeriod',
            type: 'date',
            label: 'End date (CST)',
            hint: 'Provide end date',
            value: moment().tz(AppConfig.DEFAULT_ZONEINFO).subtract(1, 'days').format('YYYYMMDD'),
            v_required: { value: true, err: 'Provide end date' },
            placement: 'left',
          },
        ],
      },
    ],
  },
});

export const venueCommandsFieldDef = {
  fieldDef: {
    title: 'Send Command to Screen',
    formType: 'edit',
    steps: [
      {
        fields: [
          {
            key: 'command',
            type: 'radio',
            label: 'Command',
            hint: 'Select Command',
            placeholder: 'Command',
            v_required: {
              value: true,
              err: 'Provide command action'
            },
            placement: 'left',
            options: [
              {
                "key": "refresh-from-cms",
                "label": "Sync to Screen"
              }
            ],
            value: 'refresh-from-cms',
            disabled: true
          }
        ]
      }
    ]
  }
}

export const attachDetachForm = {
  fieldDef: {
    title: 'Bulk Attach/Detach',
    formType: 'edit',
    steps: [
      {
        fields: [
          {
            key: 'campaignId',
            type: 'radio',
            label: 'Campaign',
            hint: 'Select Campaign',
            placeholder: 'Select Campaign',
            v_required: {
              value: true,
              err: 'Select a campaign'
            },
            placement: 'left',
            disabled: true,
          },
          {
            key: 'venueCodesStr',
            type: 'edit_text',
            label: 'Screen Codes ( Eg: DD-886547, DD-886459, DD-325352 )',
            hint: 'Enter Screen Codes',
            placeholder: 'Screen Codes ( Eg: DD-886547, DD-886459, DD-325352 )',
            v_required: {
              value: true,
              err: 'Enter Screen Codes'
            },
            placement: 'left',
            disabled: false,
            multiline: true
          },
          {
            key: 'venueCodes',
            type: 'check_box',
            label: 'Venues',
            hint: 'Select Venues',
            options: [],
            v_required: {
              value: false,
              err: 'Select Venues'
            },
            placement: 'left',
            hide: true,
           optionDisplayFields: [
            { key: 'vInfo', bold: true },
            { key: 'sInfo' },
          ]
          }
        ]
      }
    ]
  }
}

export const partnerRoleDropdownFieldDef = {
  "key": "roles",
  "type": "check_box",
  "label": "Roles",
  "hint": "Select Roles",
  "options": [
    {
      "key": "SUPERUSER",
      "label": "ADMIN"
    },
    {
      "key": "VIEWER",
      "label": "VIEWER"
    },
    {
      "key": "VENUES",
      "label": "VENUES"
    },
    {
      "key": "CAMPAIGNS",
      "label": "CAMPAIGNS"
    },
    {
      "key": "REPORTS",
      "label": "REPORTS"
    }
  ],
  "v_required": {
    "value": true,
    "err": "Select Roles"
  },
  "placement": "right"
}

export const customRoleDropdownFieldDef = {
  "key": "roles",
  "type": "check_box",
  "label": "Roles",
  "hint": "Select Roles",
  "options": [
    {
      "key": "SUPERUSER",
      "label": "ADMIN"
    }
  ],
  "v_required": {
    "value": true,
    "err": "Select Roles"
  },
  "placement": "right"
}

export const assetsFormAddition = [
  {
    key: 'startStr',
    type: 'dateTimeStr',
    label: 'Start',
    hint: 'Provide start',
    placeholder: 'MM-DD-YYYY',
    v_required: {
      value: false,
      err: 'Provide start'
    },
    placement: 'left',
    clearable: true
  },
  {
    key: 'endStr',
    type: 'dateTimeStr',
    label: 'End',
    hint: 'Provide end',
    placeholder: 'MM-DD-YYYY',
    v_required: {
      value: false,
      err: 'Provide end'
    },
    placement: 'right',
    clearable: true
  }
]

export const adminRoleDropdownFieldDef = {
  "key": "roles",
  "type": "check_box",
  "label": "Roles",
  "hint": "Select Roles",
  "options": [
    {
      "key": "SUPERUSER",
      "label": "ADMIN"
    },
    {
      "key": "INSTALLER",
      "label": "INSTALLER"
    },
    {
      "key": "CAMPAIGNS",
      "label": "CAMPAIGNS"
    },
    {
      "key": "ORGS",
      "label": "ORGS"
    },
    {
      "key": "VENUES",
      "label": "VENUES"
    },
    {
      "key": "REPORTS",
      "label": "REPORTS"
    },
    {
      "key": "VIEWER",
      "label": "VIEWER"
    }
  ],
  "v_required": {
    "value": true,
    "err": "Select Roles"
  },
  "placement": "right"
}

export const venueStateOptions = [
  { key: 'LIVE', value: 'LIVE' },
  { key: 'ARCHIVED', value: 'ARCHIVED' },
  { key: '_ALL', value: 'ALL' }
]

export const taskStateOptions = [
  { key: 'DRAFT', value: 'DRAFT' },
  { key: 'LIVE', value: 'LIVE' },
  { key: 'REJECTED', value: 'REJECTED' },
  { key: 'COMPLETED', value: 'COMPLETED' },
  { key: 'ARCHIVED', value: 'ARCHIVED' },
  { key: '_ALL', value: 'ALL' }
]

export const mediaStateOptions = [
  { key: 'LIVE', value: 'ENABLED' },
  { key: 'DISABLED', value: 'DISABLED' },
  { key: '_ALL', value: 'ALL' }
]

export const layotStateOptions = [
  { key: 'LIVE', value: 'ENABLED' },
  { key: 'DISABLED', value: 'DISABLED' },
  { key: '_ALL', value: 'ALL' }
]

export const layoutsTemplate = [
  {
    "id": 1723710152339934,
    "width": 1920,
    "height": 1080,
    "layoutName": "Horizontal Full",
    "orientation": "LANDSCAPE",
    "state": 'LIVE',
    "layoutjson": {
      "sections": [
        {
          "x": 0,
          "y": 0,
          "width": 1920,
          "height": 1080,
          "id": 1737101210395,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(231, 198, 230, 0.8)"
        }
      ]
    }
  },
  {
    "id": 1737101222334,
    "width": 1920,
    "height": 1080,
    "layoutName": "Layout Name",
    "orientation": "LANDSCAPE",
    "state": 'LIVE',
    "layoutjson": {
      "sections": [
        {
          "x": 0,
          "y": 0,
          "width": 1920,
          "height": 747,
          "id": 1737101210395,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(231, 198, 230, 0.8)"
        },
        {
          "x": 0,
          "y": 747,
          "width": 1920,
          "height": 333,
          "id": 1737101222334,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(202, 225, 225, 0.8)"
        }
      ]
    }
  },
  {
    "id": 1737101337905,
    "width": 1920,
    "height": 1080,
    "layoutName": "Landscape 2",
    "orientation": "LANDSCAPE",
    "state": 'LIVE',
    "layoutjson": {
      "sections": [
        {
          "x": 0,
          "y": 0,
          "width": 1120,
          "height": 753,
          "id": 1737101328084,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(218, 242, 164, 0.8)"
        },
        {
          "x": 1120,
          "y": 0,
          "width": 800,
          "height": 753,
          "id": 1737101332503,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(219, 191, 215, 0.8)"
        },
        {
          "x": 0,
          "y": 753,
          "width": 1920,
          "height": 327,
          "id": 1737101337905,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(192, 184, 209, 0.8)"
        }
      ]
    }
  },
  {
    "id": 1737101328084,
    "width": 1920,
    "height": 1080,
    "layoutName": "Landscape 3",
    "orientation": "LANDSCAPE",
    "state": 'LIVE',
    "layoutjson": {
      "sections": [
        {
          "x": 0,
          "y": 0,
          "width": 981,
          "height": 1080,
          "id": 1737101328084,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(218, 242, 164, 0.8)"
        },
        {
          "x": 981,
          "y": 0,
          "width": 939,
          "height": 1080,
          "id": 1737101332503,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(219, 191, 215, 0.8)"
        }
      ]
    }
  },
  {
    "id": 173710152339934,
    "width": 1080,
    "height": 1920,
    "layoutName": "Vertical Full",
    "orientation": "PORTRAIT",
    "state": 'LIVE',
    "layoutjson": {
      "sections": [
        {
          "x": 0,
          "y": 0,
          "width": 1080,
          "height": 1920,
          "id": 1737101210395,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(231, 198, 230, 0.8)"
        }
      ]
    }
  },
  {
    "id": 1737101539934,
    "width": 1080,
    "height": 1920,
    "layoutName": "Portrait 2",
    "orientation": "PORTRAIT",
    "state": 'LIVE',
    "layoutjson": {
      "sections": [
        {
          "x": 0,
          "y": 0,
          "width": 1080,
          "height": 1553,
          "id": 1737101539934,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(230, 173, 151, 0.8)"
        },
        {
          "x": 0,
          "y": 1553,
          "width": 1080,
          "height": 367,
          "id": 1737101547030,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(208, 183, 211, 0.8)"
        }
      ]
    }
  },
  {
    "id": 1737101547039,
    "width": 1080,
    "height": 1920,
    "layoutName": "Portrait 3",
    "orientation": "PORTRAIT",
    "state": 'LIVE',
    "layoutjson": {
      "sections": [
        {
          "x": 0,
          "y": 0,
          "width": 1080,
          "height": 981,
          "id": 1737101539934,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(230, 173, 151, 0.8)"
        },
        {
          "x": 0,
          "y": 981,
          "width": 1080,
          "height": 939,
          "id": 1737101547030,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(208, 183, 211, 0.8)"
        }
      ]
    }
  },
  {
    "id": 1737101774887,
    "label": "HD 1080p",
    "width": 1080,
    "height": 1920,
    "layoutName": "Portrait 4",
    "orientation": "PORTRAIT",
    "state": 'LIVE',
    "layoutjson": {
      "sections": [
        {
          "x": 0,
          "y": 0,
          "width": 1080,
          "height": 821,
          "id": 1737101763684,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(252, 228, 221, 0.8)"
        },
        {
          "x": 0,
          "y": 821,
          "width": 551,
          "height": 1099,
          "id": 1737101767423,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(199, 248, 221, 0.8)"
        },
        {
          "x": 551,
          "y": 821,
          "width": 529,
          "height": 1099,
          "id": 1737101774887,
          "type": "section",
          "zIndex": 1,
          "backgroundColor": "rgba(215, 155, 220, 0.8)"
        }
      ]
    }
  }
]

export const orgGroups = [
  { key: 'FA', value: 'FA' },
  { key: 'PA', value: 'PA' },
  { key: 'PARTNER', value: 'PARTNER' },
  { key: 'SUPERPARTNER', value: 'SUPERPARTNER' },
  { key: 'SITE', value: 'SITE' },
  { key: '_ALL', value: 'ALL' }
]

export const taskExtraFieldsToShow = [{
  "key": "createdTs",
  "type": "dateTime",
  "label": "Created On",
},
{
  "key": "completedTs",
  "type": "dateTime",
  "label": "Completed On",
},
{
  "key": "rejectedTs",
  "type": "dateTime",
  "label": "Rejected On",
},
{
  "key": "rejectionComments",
  "type": "edit_text",
  "label": "Rejection Comments",
}]

export const paymentLinkFields = {
  fieldDef: {
    ctaButtonText: 'Generate',
    title: 'Generate Payment URL',
    formType: 'edit',
    steps: [
      {
        fields: [
          {
            key: 'amount',
            type: 'edit_text',
            label: 'Price (USD)',
            hint: 'Provide amount',
            placeholder: 'Provide price',
            v_required: {
              value: true,
              err: 'Provide price'
            },
            placement: 'left',
            clearable: true
          },
          {
            key: 'durationMonths',
            type: 'edit_text',
            label: 'Duration (months)',
            hint: 'Provide Duration',
            placeholder: 'Provide Duration',
            v_required: {
              value: true,
              err: 'Provide Duration'
            },
            placement: 'left',
            clearable: true
          },
        ]
      }
    ]
  }
}


export const creativeFields = {
  "fieldDef": {
    title: 'Creatives',
    formType: 'edit',
    "steps": [
      {
        "fields": [
          {
            "key": "state",
            "type": "radio",
            "label": "Action",
            "hint": "Select State",
            "options": [
              {
                "key": "HOLD",
                "label": "HOLD"
              },
              {
                "key": "APPROVED",
                "label": "APPROVED"
              },
              {
                "key": "REJECTED",
                "label": "REJECTED"
              },
            ],
            "v_required": {
              "value": true,
              "err": "Select State"
            },
            "placement": "left"
          },
          {
            "key": "stateChangeReason",
            "type": "edit_text",
            "multiline": true,
            "label": "State Change Reason (optional)",
            "hint": "Select State",
            "v_required": {
              "value": false,
              "err": "State Change Reason"
            },
            "placement": "left"
          }
        ]
      }
    ]
  }
}

export const creativeFieldsWithFieldsMandatory = {
  "fieldDef": {
    title: 'Creatives - Approve or Block for All Screens',
    formType: 'edit',
    "steps": [
      {
        "fields": [
          {
            "key": "state",
            "type": "radio",
            "label": "Action",
            "hint": "Select State",
            "options": [
              {
                "key": "HOLD",
                "label": "HOLD"
              },
              {
                "key": "APPROVED",
                "label": "APPROVED"
              },
              {
                "key": "REJECTED",
                "label": "REJECTED"
              },
            ],
            "v_required": {
              "value": true,
              "err": "Select State"
            },
            "placement": "left"
          },
          {
            "key": "stateChangeReason",
            "type": "edit_text",
            "multiline": true,
            "label": "State Change Reason",
            "hint": "Select State",
            "v_required": {
              "value": true,
              "err": "Provide a reason for state change"
            },
            "placement": "left"
          }
        ]
      }
    ]
  }
}

export const screenPerformanceFilterFieldDef = {
  fieldDef: {
    title: 'Filter',
    formType: 'edit',
    ctaButtonText: 'Apply',
    steps: [
      {
        fields: [
          {
            key: 'startDate',
            type: 'date',
            label: 'Start Date',
            hint: 'Select Start Date',
            defaultValue: '',
            v_required: {
              value: false,
              err: 'Select Start Date'
            },
            placement: 'left'
          },
          {
            key: 'endDate',
            type: 'date',
            label: 'End Date',
            hint: 'Select End Date',
            defaultValue: '',
            v_required: {
              value: false,
              err: 'Select End Date'
            },
            placement: 'right'
          },
          // {
          //   key: 'venueCode',
          //   type: 'edit_text',
          //   label: 'Venue Code',
          //   hint: 'Paste Venue Code',
          //   defaultValue: '',
          //   v_required: {
          //     value: false,
          //     err: 'Enter Venue Code'
          //   },
          //   placement: 'left'
          // },
          {
            key: 'partner',
            type: 'select',
            label: 'Partner',
            hint: 'Select Partner',
            options: [],
            defaultValue: '',
            v_required: {
              value: false,
              err: 'Select Partner'
            },
            placement: 'right'
          },
          {
            key: 'site',
            type: 'select',
            label: 'Site',
            hint: 'Select Site',
            options: [],
            defaultValue: '',
            v_required: {
              value: false,
              err: 'Select Site'
            },
            placement: 'left'
          }
        ]
      }
    ]
  }
};

export const creativeTagsFieldDef = {
  fieldDef: {
    title: 'Tags',
    formType: 'edit',
    ctaButtonText: 'Confirm selected tags',
    steps: [
      {
        fields: [
          {
            key: 'tags',
            type: 'select',
            multiSelect: true,
            label: 'Select Valid Tag(s)',
            hint: 'Select Valid Tag(s)',
            options: [],
            defaultValue: [],
            v_required: { value: false, err: 'Select Valid Tag(s)' },
            placement: 'left',
          }
        ]
      }
    ]
  }
}

export const ddSearchFilterFieldDef = {
  fieldDef: {
    title: 'Filter',
    formType: 'edit',
    ctaButtonText: 'Apply',
    steps: [
      {
        fields: [
          {
            key: 'exchange',
            type: 'select',
            multiSelect: true,
            label: 'Exchange',
            hint: 'Select Exchange',
            options: [
              { key: 'PU', label: 'Publica' },
              { key: 'PO', label: 'PlaceExchange OTT' },
              { key: 'VS', label: 'Vesta' },
              { key: 'IN', label: 'Indicue' },
            ],
            defaultValue: [],
            v_required: { value: false, err: 'Select Exchange' },
            placement: 'left',
          },
          {
            key: 'iabCategories',
            type: 'select',
            multiSelect: true,
            label: 'IAB Categories',
            hint: 'Select IAB Category',
            options: [
              { key: 'IAB1', label: 'IAB1' },
              { key: 'IAB2', label: 'IAB2' },
            ],
            defaultValue: [],
            v_required: { value: false, err: 'Select IAB Category' },
            placement: 'right',
          },
          {
            key: 'tags',
            type: 'select',
            multiSelect: true,
            label: 'Tags',
            hint: 'Select Tag',
            options: [],
            defaultValue: [],
            v_required: { value: false, err: 'Select Tag' },
            placement: 'right',
          },
          {
            key: 'mimetype',
            type: 'select',
            multiSelect: true,
            label: 'MIME Type',
            hint: 'Select MIME Type',
            options: [
              { key: 'image', label: 'Image' },
              { key: 'video', label: 'Video' },
              { key: 'other', label: 'Other' },
            ],
            defaultValue: [],
            v_required: { value: false, err: 'Select MIME Type' },
            placement: 'left',
          },
          {
            key: 'adRating',
            type: 'select',
            multiSelect: true,
            label: 'Ad Rating',
            hint: 'Select Ad Rating',
            options: [
              { key: 'PG', label: 'PG' },
              { key: 'PG-U', label: 'PG-U' },
            ],
            defaultValue: [],
            v_required: { value: false, err: 'Select Ad Rating' },
            placement: 'right',
          },
          {
            key: 'orientation',
            type: 'select',
            multiSelect: true,
            label: 'Orientation',
            hint: 'Select Orientation',
            options: [
              { key: 'landscape', label: 'LANDSCAPE' },
              { key: 'portrait', label: 'PORTRAIT' },
            ],
            defaultValue: [],
            v_required: { value: false, err: 'Select Orientation' },
            placement: 'left',
          },
          {
            key: 'state',
            type: 'select',
            multiSelect: true,
            label: 'State',
            hint: 'Select State',
            options: [
              { key: 'HOLD', label: 'HOLD' },
              { key: 'REJECTED', label: 'REJECTED' },
              { key: 'APPROVED', label: 'APPROVED' },
            ],
            defaultValue: [],
            v_required: { value: false, err: 'Select State' },
            placement: 'right',
          },
          {
            key: 'durationsecs',
            type: 'select',
            multiSelect: true,
            label: 'Duration',
            hint: 'Select Duration',
            options: [],
            defaultValue: [],
            v_required: { value: false, err: 'Select Duration' },
            placement: 'left',
          },
        ],
      },
    ],
  },
}



// WEBPACK FOOTER //
// ./src/data/data.js